import { differenceInSeconds } from 'date-fns';
export const getMinutesUntilDate = (date) => differenceInSeconds(date, Date.now()) / 60;
